module.exports = __webpack_public_path__ + "img/sms-edit.5056e82c.svg";